import React from "react";
import { routes } from "consts";
import { useParams } from "react-router-dom";
import { useToaster } from "utils";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { PageMain } from "components/molecules";
import { PaziaBox } from "components/atoms";
import { PaziaLoader } from "components/atoms";
import { coursegroupAttributesApi, useCourseGroupAttribute } from "api/coursegroup-attributes";
import { CourseGroupAttributeForm, CourseGroupAttributeFormValues } from "./CourseGroupAttributeForm";

export const CourseGroupAttributeEditPage = () => {
  const { attributeId } = useParams();
  const { isLoading, attribute, invalidate } = useCourseGroupAttribute(attributeId);
  const { showSuccess, showError } = useToaster();

  const onSubmit = async (data: CourseGroupAttributeFormValues) => {
    try {
      await coursegroupAttributesApi.update(Number(attributeId), {
        name: data.name,
        attributeType: data.attributeType,
        options: data.options?.map((o) => ({
          id: o.id,
          value: o.value,
          numericValue: o.numericValue ?? null,
          sortOrder: o.sortOrder,
          color: o.color || null,
        })),
      });
      showSuccess(`Zaktualizowano atrybut "${data.name}"`);
      invalidate();
    } catch {
      showError("Nie udało się zaktualizować atrybutu");
    }
  };

  if (isLoading) return <PaziaLoader position="center" />;
  if (!attribute) return null;

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[
          { title: "Grupy kursów", path: routes.COURSE_GROUPS },
          { title: "Atrybuty", path: routes.COURSE_GROUPS_ATTRIBUTES },
          { title: attribute.name },
        ]}
        headerText={`Edycja atrybutu: ${attribute.name}`}
      />
      <PaziaBox>
        <CourseGroupAttributeForm attribute={attribute} onSubmit={onSubmit} />
      </PaziaBox>
    </PageMain>
  );
};
